import styles from './FormDesigner.module.scss';
import React, { Suspense } from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
// eslint-disable-next-line no-restricted-imports
import type { Model, DesignerProps } from '@webinex/dynamic-form';
import { FormDynamicElements } from './FormDynamicElements';

export interface FormDesignerProps extends Omit<DesignerProps, 'model' | 'onChange' | 'Elements'> {
  name: string;
}

const Lazy = React.lazy(async () => {
  const { Designer } = await import('@webinex/dynamic-form');
  const Elements = await FormDynamicElements.DesignerElements();

  return {
    default: function FormDesignerInner(props: FormDesignerProps) {
      const { name, className, offsetTop, ...designerProps } = props;
      const [{ value }, , { setValue }] = useField<Model>(name);

      return (
        <Designer.Group
          {...designerProps}
          className={classNames(className, styles.designer)}
          offsetTop={offsetTop}
          model={value!}
          onChange={setValue}
          Elements={Elements}
          noPreviewControls
        />
      );
    },
  };
});

export function FormDesigner(props: FormDesignerProps) {
  return (
    <Suspense fallback="Loading...">
      <Lazy {...props} />
    </Suspense>
  );
}
